import React, { useState, useId } from 'react';
import styled from 'styled-components';
import { useAppContext } from '@prisjakt/ui-app-context';
import { CardContent } from '@prisjakt/ui/card';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { Popover, Alignment } from '@prisjakt/ui/popover';
import { ClickOutButton } from '../click-out-button';
import { BaseProps } from '../../types';

type Props = Pick<BaseProps, 'link' | 'onClick' | 'store'>;

export const GridCardOfferFooter: React.FC<Props> = props => {
  const { store, link, onClick } = props;
  const { t } = useAppContext();
  const [showPopover, setShowPopover] = useState(false);
  const uid = useId();
  const disabled = !onClick || !link;

  const handleClick = () => {
    if (disabled) {
      setShowPopover(true);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <FooterContent>
        <ClickOutButton
          containerProps={{ 'aria-describedby': `offer-${uid}` }}
          store={store}
          href={link || ''}
          onClick={handleClick}
          featured={store && store.featured}
        />
      </FooterContent>

      {disabled && (
        <Popover
          id={`offer-${uid}`}
          visible={showPopover}
          width={250}
          offsetY={0}
          offsetX={0}
          verticalAlign={Alignment.End}
          horizontalAlign={Alignment.Center}
          onClose={() => setShowPopover(false)}
          zIndex={20}
        >
          <BodySmallText>
            {t('product', 'transparency.store-info')}
          </BodySmallText>
        </Popover>
      )}
    </>
  );
};

const FooterContent = styled(CardContent)`
  && {
    justify-self: flex-end;
    flex: 0;
    padding: 0;
  }
`;
